import React, { useState, type FunctionComponent } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Radio, Row, Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { type AppStore } from "@fitness-app/app-store";
import { IntegrationClient } from "@fitness-app/data-models/entities/ProductsSettings";

import CalendlyIntegration from "./integration/CalendlyIntegration/CalendlyIntegration";
import NotionIntegration from "./integration/NotionIntegration/NotionIntegration";
import { integrationOptions } from "./integration/options";

interface OwnProps {}

type Props = OwnProps;

const AdditionalIntegrations: FunctionComponent<Props> = () => {
  const { t } = useTranslation("settings");
  const { data } = useSelector((state: AppStore) => state.productsSettings);

  const [selectedIntegration, setIntegration] = useState<IntegrationClient>(IntegrationClient.Calendly);

  const integrationElements: { [K in IntegrationClient]?: React.ReactNode } = {
    [IntegrationClient.Notion]: <NotionIntegration integration={data?.extra?.[IntegrationClient.Notion] || null} />,
    [IntegrationClient.Calendly]: (
      <CalendlyIntegration integration={data?.extra?.[IntegrationClient.Calendly] || null} />
    ),
  };

  const renderActiveIntegration = () => {
    return integrationElements[selectedIntegration];
  };

  return (
    <div className="flex flex-col items-center gap-4 pt-5">
      <Space direction="vertical" size={24}>
        <Row gutter={24} justify="center">
          <Radio.Group size="large" value={selectedIntegration} onChange={(e) => setIntegration(e.target.value)}>
            {integrationOptions
              .filter((client) => !client.hidden)
              .map((client) => (
                <Tooltip title={client.disabled ? t<string>("common:availableSoon") : undefined} key={client.value}>
                  <Radio.Button value={client.value} disabled={client.disabled}>
                    <img
                      src={client.icon}
                      alt={`${client.value}-icon`}
                      className="mx-2 my-0 h-5 w-5 object-contain align-text-bottom"
                    />
                    {t<string>(`common:integration.${client.value}`)}
                    {data?.extra && client.value in data.extra && data.extra?.[client.value]?.length ? (
                      <CheckCircleOutlined style={{ color: "#1bc5bd", marginLeft: 8 }} />
                    ) : null}
                  </Radio.Button>
                </Tooltip>
              ))}
          </Radio.Group>
        </Row>
      </Space>
      {renderActiveIntegration()}
    </div>
  );
};

export default AdditionalIntegrations;
